export namespace ExceptionWithDebuggingHint {
    /** 
     * Translated from enum com.dataiku.dip.exceptions.ExceptionWithDebuggingHint$DebuggingHint
     * Via: UIModel annotation in the class hierarchy
     */
    export enum DebuggingHint {
        CHECK_JOB_LOG = "CHECK_JOB_LOG",
        CHECK_BACKEND_LOG = "CHECK_BACKEND_LOG",
    }
}